import { Injectable } from '@angular/core';
import { of, Subject, BehaviorSubject, Observable, combineLatest } from 'rxjs';
import { tap, switchMap, skip, share, map, filter, shareReplay, distinctUntilChanged, takeUntil, takeWhile, take } from 'rxjs/operators';
import { DefaultIndexDoc } from '@app/graphql';
import { ScrollService, PagesService, TaxonomyService, PageService } from '@app/data';
import { PageName, TaxonomyPageName, SortBy, CONSTANTS, Chip, Partner, School, Question, Person, ParentRoute, ParentSubPage, Taxonomies, ParamsType } from '@app/constants';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  public currentTaxonomyPage$ = this.page.currentTaxonomyPage$;
  public route$ = this.pages.route$;
  public queryParams$ = this.pages.queryParams$;
  public about$ = this.page.getTaxonomyPages$('about');
  public routeAnimationParams$ = new BehaviorSubject<any>({value: -1, params: {y: '0px', animationDuration: '0.8s'} });
  public lastRoute$ = new BehaviorSubject<any>({route: {url: [{path: ''}]}});

  constructor(
    private scroll: ScrollService,
    private page: PageService,
    private pages: PagesService

  ) {}

  /* SECTION CLASS */

  public getClass = (): string => this.pages.getSectionName();

  /* ROUTES */

  public getRoutes$ = (): Observable<ParentRoute[]> => this.page.getTaxonomyPages$('routes');
  public getRouteAnimationParams$ = (): any => this.routeAnimationParams$;
  public setRouteAnimationParams$ = (params: any): any => this.routeAnimationParams$.next(params);
  public getRouteAnimationParams = (): any => this.routeAnimationParams$.value;
  public getLastRoute = (): any => this.lastRoute$.value;
  public setLastRoute = (route: any): any => this.lastRoute$.next(route);

  /* PAGES */

  public getCurrentPage = (): any => this.pages.getCurrentPage();
  public getCurrentPageName = (): string => this.pages.getCurrentPageName();
  public normalizePageName = (path: any): PageName => {
    //console.log('DataService normalizePageName path ', path);
    let name = path;

    //get path from parent strana queryParams
    if (name.includes('/')) {
      name = name.split('/')[1];
    }

    // simplify names
    if (name.includes('-')) {
       name = name.split('-')[1];
    }

    const pageName: PageName = name;

    return pageName;
  };

  /* SUBPAGES */

  public getSubPages$ = (): Observable<Taxonomies[]> => this.page.getTaxonomyPages$('subpages');

  /* TAXONOMY */

  public getTaxonomyPageName = (): string => {
    const path = this.pages.getCurrentPageName();
    //console.log('DataService getTaxonomyPageName path ', path);

    let taxonomy: string = 'skoly';

    switch (path) {
      case '/inspirace/inspirativni-skoly': {
        taxonomy = 'skoly';
        break;
      }

      case '/inspirace/inspirativni-organizace': {
        taxonomy = 'partneri';
        break;
      }
    }

    return taxonomy;
  }

  /* BACK BTN QUERY PARAMS */

  public clearParentQueryParams = (params: ParamsType, clearSubpage: boolean): ParamsType => {
    //console.log('DataService clearParentQueryParams params ', params);
    const page = this.getCurrentPage();
    //console.log('DataService clearParentQueryParams page ', page);

    let newParams = {...params};

    if (newParams.sekce && newParams.sekce.indexOf(page.pageName) > 0) {
      delete newParams.sekce;
    }

    if (newParams.strana && page.data.clearPager) {
      delete newParams.strana;
    }

    if (newParams.podstranka && clearSubpage && page.data.detail !== true) {
      delete newParams.podstranka;
    }

    return newParams;
  };

  /* SCROLL */

  public scrollToPosition = (pos: [number, number]): void => {
    //console.log('**** DataService scroll scrollToPosition **** pos ', pos);
    this.scroll.scrollToPosition(pos);
  };

  public setScrollIntoView = (id: string): void => this.scroll.setScrollIntoView(id); 
}
